// extracted by mini-css-extract-plugin
export default {"Label":"Label__Label___i7032"};